import { authorize, getRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function getUserIn2nAPI(userEmail) {
  const url = `${AWS_API_URL}/2n/users?email=${encodeURIComponent(userEmail)}`;

  return getRequest(url, await authorize());
}
